    import React, { useEffect, useState } from 'react';
    import {useDispatch, useSelector} from 'react-redux';
    import PokemonCard from '../components/PokemonCard';
    import {Link} from "react-router-dom";
    import {toast, ToastContainer} from "react-toastify";
    import axios from "axios";
    import { shuffle as shufflePokemonTeam1} from '../teams/Team1Slice';
    import { shuffle as shufflePokemonTeam2} from '../teams/Team2Slice';

    const TeamWinCal = () => {

        const team1 = useSelector(state => state.team1.team);
        const team2 = useSelector(state => state.team2.team);
        const  [team1winrate,setTeam1Winrate] = useState();
        const  [team2winrate,setTeam2Winrate] = useState();
        const dispatch = useDispatch();
        const Rate = ({rate}) => {
            if(!rate)
            {
                return
            }
            return(
                <>{rate}% win rate</>
            )
        }
        const Shuffle = () => {
            dispatch(shufflePokemonTeam1())
            dispatch(shufflePokemonTeam2())

        }
        const calculateWinRate = async () => {
            if (team1.length !== team2.length) {
                toast.error("Oba týmy musí mít stejný počet Pokémonů!");
                return;
            }
            let a = 0;
            for (let i = 0; i < team1.length; i++) {
                const poke1 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${team1[i]}`);
                const poke2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${team2[i]}`);

                const pokemon1 = poke1.data;
                const pokemon2 = poke2.data;

                const typeData = await fetchTypeData(pokemon1, pokemon2);
                if (!typeData) return;

                const winrate = await calculateMatchup(pokemon1, pokemon2, typeData.dmg1, typeData.dmg2);
                a+= winrate;
                console.log(a)
            }
            final(a)
        };
        const final = (a) => {
            console.log(a)
            setTeam1Winrate(a/5);
            setTeam2Winrate((500-a)/5)
        }
        const fetchTypeData = async (pokemon1, pokemon2) => {
            try {
                const poke1type = pokemon1.types;
                const poke2type = pokemon2.types;

                const typeUrls1 = poke1type.map(t => t.type.url);
                const typeUrls2 = poke2type.map(t => t.type.url);

                const res1 = await Promise.all(typeUrls1.map(url => axios.get(url)));
                const res2 = await Promise.all(typeUrls2.map(url => axios.get(url)));

                return { dmg1: res1, dmg2: res2 };
            } catch (error) {
                console.error("Chyba při načítání typů:", error);
                return null;
            }
        };



    const calculateMatchup = async (pokemon1, pokemon2, dmg1, dmg2) => {
        let selectedPokemon1 = pokemon1;
        let selectedPokemon2 = pokemon2;
        if (!(pokemon1 && pokemon2)) {
            return
        }



        if (!(dmg1 && dmg2)) {
            return console.log("b");
        }

        const poke1Relations = dmg1.map(res => ({
            type: res.data.name,
            damage_relations: res.data.damage_relations
        }));

        const poke2Relations = dmg2.map(res => ({
            type: res.data.name,
            damage_relations: res.data.damage_relations
        }));

        //console.log("Vztahy pro Pokémon 1:", poke1Relations);
        //console.log("Vztahy pro Pokémon 2:", poke2Relations);

        let poke1atk = parseInt(selectedPokemon1.stats[1].base_stat);
        let poke2atk = parseInt(selectedPokemon2.stats[1].base_stat);
        let poke1spatk = parseInt(selectedPokemon1.stats[3].base_stat);
        let poke2spatk = parseInt(selectedPokemon1.stats[3].base_stat);
        let poke1def = parseInt(selectedPokemon1.stats[2].base_stat);
        let poke2def = parseInt(selectedPokemon1.stats[2].base_stat);
        let poke1spdef = parseInt(selectedPokemon1.stats[4].base_stat);
        let poke2spdef = parseInt(selectedPokemon1.stats[4].base_stat);

        console.log(poke2Relations)
        console.log(poke1Relations)
        let countDoubleTo = 0;
        let countHalfTo = 0;
        //console.log(poke1atk)
        //console.log(poke2atk)
        let poke1stats = 0;
        let poke2stats = 0;
        console.log(pokemon1)
        console.log(pokemon2)
        for(let i = 0; i<pokemon1.stats.length;i++)
        {
            poke1stats += parseInt(selectedPokemon1.stats[i].base_stat)
        }
        for(let i = 0; i<pokemon2.stats.length;i++)
        {
            poke2stats += parseInt(selectedPokemon2.stats[i].base_stat)

        }
        console.log(poke1stats)
        console.log(poke2stats)
        poke1stats = poke1stats - poke1atk;
        poke2stats = poke2stats - poke2atk;
        poke1stats = poke1stats - poke1spatk;
        poke2stats = poke2stats - poke2spatk;
        poke2stats = poke2stats - poke2def;
        poke1stats = poke1stats - poke1def;
        poke2stats = poke2stats - poke2spdef;
        poke1stats = poke1stats - poke1spdef;
        poke1stats += parseInt(pokemon1.base_experience)
        poke2stats += parseInt(pokemon2.base_experience)
        if(pokemon1.weight > 3000)
        {
            poke1stats += parseInt(pokemon1.weight) /3

        }
        else
        {
            poke1stats += parseInt(pokemon1.weight)

        }
        if(pokemon2.weight >3000)
        {
            poke2stats += parseInt(pokemon2.weight)/3
        }
        else{
            poke2stats += parseInt(pokemon2.weight)
        }


        for(let i = 0; i< poke1Relations.length;i++)//pro prvniho pokemona
        {
            //poke1Relations[i]
            // console.log(poke1Relations[i].damage_relations)

            for(var a in poke1Relations[i].damage_relations.double_damage_to)
            {
                //console.log(poke1Relations[i].damage_relations.double_damage_to[a].name)
                for(let c = 0; c<poke2Relations.length;c++) {
                    if (poke2Relations[c].type === poke1Relations[i].damage_relations.double_damage_to[a].name && countDoubleTo === 0)
                    {
                        poke1spatk = poke1spatk *3;
                        poke1atk = poke1atk * 1.7;
                        countDoubleTo ++;
                        poke1stats = poke1stats * 1.1
                    }
                }

            }
            for(var a in poke1Relations[i].damage_relations.half_damage_to)
            {
                //console.log(poke1Relations[i].damage_relations.half_damage_to[a].name)
                for(let c = 0; c<poke2Relations.length;c++) {
                    if (poke2Relations[c].type === poke1Relations[i].damage_relations.half_damage_to[a].name && countHalfTo === 0)
                    {
                        poke1atk = poke1atk /1.5;
                        poke1spatk = poke1spatk / 1.1;
                        poke1spdef = 60
                        poke1def = 40
                        countHalfTo ++;
                    }
                }

            }
        }
        countDoubleTo = 0;
        countHalfTo = 0;
        for(let i = 0; i< poke2Relations.length;i++)//pro drureho pokemona
        {


            for(var a in poke2Relations[i].damage_relations.double_damage_to)
            {
                //console.log(poke2Relations[i].damage_relations.double_damage_to[a].name)
                for(let c = 0; c<poke1Relations.length;c++) {
                    if (poke1Relations[c].type === poke2Relations[i].damage_relations.double_damage_to[a].name && countDoubleTo === 0)
                    {
                        poke2atk = poke2atk * 1.7;
                        poke2spatk = poke2spatk * 3
                        poke2stats = poke2stats * 1.1
                        countDoubleTo ++;
                    }
                }

            }
            for(var a in poke2Relations[i].damage_relations.half_damage_to)
            {
                //console.log(poke2Relations[i].damage_relations.half_damage_to[a].name)
                for(let c = 0; c<poke1Relations.length;c++) {
                    if (poke1Relations[c].type === poke2Relations[i].damage_relations.half_damage_to[a].name && countHalfTo === 0)
                    {

                        poke2atk = poke2atk / 1.5;
                        poke2spatk = poke2spatk /1.1;
                        poke2spdef = 60
                        poke2def = 40
                        countHalfTo ++;


                    }
                }

            }
        }
        console.log(poke1stats)
        console.log(poke2stats)
        let count = 0;
        for(let i = 0; i<pokemon1.types.length;i++)
        {
            if(selectedPokemon1.types[i].type.name == "psychic" && parseInt(pokemon1.weight) > 100)
            {

                poke1stats = poke1stats * 1.3


            }
            if(count === 0)
            {
                if(pokemon1.name === "mewtwo" || pokemon1.name === "mewtwo-mega-x" || pokemon1.name === "mewtwo-mega-y") {

                    poke1stats = poke1stats * 2;
                    count++;
                    //console.log(poke1stats)

                }
                else if (pokemon1.name == "mew")
                {
                    poke1stats = poke1stats * 5;
                }
            }

            if(selectedPokemon1.types[i].type.name == "steel")
            {
                poke1stats = poke1stats * 1.2222222222;

            }
        }

        if(pokemon1.name.slice(-2) == "-y" || pokemon1.name.slice(-2) == "-x" && pokemon1.name === "mewtwo-mega-x" && pokemon1.name === "mewtwo-mega-y")
        {
            poke1stats = poke1stats * 1.7
        }
        if(pokemon2.name.slice(-2) == "-y" || pokemon2.name.slice(-2) == "-x" && pokemon2.name === "mewtwo-mega-x" && pokemon2.name === "mewtwo-mega-y")
        {
            poke2stats = poke2stats * 1.7
        }
        count = 0;
        for(let i = 0; i<pokemon2.types.length;i++)
        {
            if(selectedPokemon2.types[i].type.name == "psychic" && parseInt(pokemon2.weight) > 100)
            {
                poke2stats = poke2stats * 1.3
            }
            if(count === 0) {
                if (pokemon2.name === "mewtwo" || pokemon2.name === "mewtwo-mega-x" || pokemon2.name === "mewtwo-mega-y") {

                    poke2stats = poke2stats * 2;
                    count++;

                }
                else if(pokemon2.name == "mew")
                {
                    poke2stats = poke2stats * 5
                }
            }

            if(selectedPokemon2.types[i].type.name == "steel")
            {
                poke2stats = poke2stats * 1.2222222222;
            }
        }

        if(pokemon1.name == "ditto" && pokemon2.name != "ditto" && pokemon2.name != "mew" && pokemon2.name != "mewtwo"&&pokemon2.name != "mewtwo-mega-y" && pokemon2.name != "mewtwo-mega-x")
        {
            poke1stats = poke2stats * 2;
        }
        if(pokemon1.name != "ditto" && pokemon2.name == "ditto" && pokemon1.name != "mewtwo" && pokemon1.name != "mewtwo" &&pokemon1.name != "mewtwo-mega-y" && pokemon1.name != "mewtwo-mega-x")
        {
            poke2stats = poke1stats * 2;
        }
        //console.log(poke1atk)
        //console.log(poke2atk)
        poke2stats += poke2atk;
        poke1stats += poke1atk;
        poke1stats += poke1spatk + poke1def + poke1spdef;
        poke2stats += poke2spatk + poke2def + poke2spdef;
        console.log(poke1stats)
        console.log(poke2stats)
        if(pokemon1.name === "mewtwo-mega-y" && pokemon2.name === "mewtwo-mega-x")
        {
            poke1stats = poke2stats
        }
        else if(pokemon1.name ==="mewtwo-mega-x" && pokemon2.name === "mewtwo-mega-y")
        {
            poke1stats = poke2stats
        }
        let poke1proc = 0;
        let fin = 0;

        let procent = 0;
        if(poke1stats === poke2stats)
        {
            fin = 50;
        }
        else if(poke1stats > poke2stats)
        {
            poke1proc =poke1stats - poke2stats * 1.5
            if(poke1proc < 0)
            {
                poke1proc = poke1proc*-1;

            }
            procent =  (poke1stats + poke2stats -poke1proc) / 100;
            fin = (poke2stats-poke1proc)/procent
        }
        else if(poke2stats > poke1stats){
            poke1proc = poke2stats - poke1stats
            if(poke1proc < 0)
            {
                poke1proc = poke1proc*-1;

            }
            procent =  (poke1stats + poke2stats -poke1proc) / 100;

            fin = (poke1stats-poke1proc)/procent;
        }

        if(poke1stats < poke2stats )
        {

        }
        else
        {
            //console.log(fin);
            fin = 100 - fin;
        }
        if(fin > 100) fin = 100
        if(fin <0) fin = 0;
        //console.log(poke1proc)
        //console.log(fin)
        fin =  Math.round(fin)
        return fin;

    };

    const Team1Page = () => {
        const [pokemonData, setPokemonData] = useState([]);
        const [loading, setLoading] = useState(true);
        useEffect(() => {
            if (team1.length > 0) {
                setLoading(true);
                const fetchAllPokemon = async () => {
                    try {
                        const promises = team1.map(name =>
                            fetch(`https://pokeapi.co/api/v2/pokemon/${name.toLowerCase()}`).then(res => res.json())
                        );
                        const results = await Promise.all(promises);
                        setPokemonData(results);
                    } catch (error) {
                        console.error(error);
                        setPokemonData([]);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchAllPokemon();
            } else {
                setPokemonData([]);
                setLoading(false);
            }
        }, [team1]);


        if (loading) return <div className="flex items-center justify-center min-h-screen">Načítám...</div>;

        return (
            <div className="w-full mt-8 p-6 bg-white rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold mb-6 text-center">Team 1 </h1>
                <div className="flex flex-wrap gap-2 ">
                    {pokemonData.map(pokemon => (
                        <PokemonCard
                            key={pokemon.id}
                            name={pokemon.name}
                            src={pokemon.sprites.front_default}
                            color={pokemon.types}
                        />
                    ))}
                </div>
                team 1: <Rate rate={team1winrate}/>
            </div>

        );
    };
    const Team2Page = () => {
        const [pokemonData, setPokemonData] = useState([]);
        const [loading, setLoading] = useState(true);
        useEffect(() => {
            if (team2.length > 0) {
                setLoading(true);
                const fetchAllPokemon = async () => {
                    try {
                        const promises = team2.map(name =>
                            fetch(`https://pokeapi.co/api/v2/pokemon/${name.toLowerCase()}`).then(res => res.json())
                        );
                        const results = await Promise.all(promises);
                        setPokemonData(results);
                    } catch (error) {
                        console.error(error);
                        setPokemonData([]);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchAllPokemon();
            } else {
                setPokemonData([]);
                setLoading(false);
            }
        }, [team2]);


        if (loading) return <div className="flex items-center justify-center min-h-screen">Načítám...</div>;

        return (
            <div>
                <div className="w-full mt-8 p-6 bg-white rounded-lg shadow-lg">
                    <h1 className="text-3xl font-bold mb-6 text-center">Team 2 </h1>
                    <div className="flex flex-wrap gap-2 ">
                        {pokemonData.map(pokemon => (
                            <PokemonCard
                                key={pokemon.id}
                                name={pokemon.name}
                                src={pokemon.sprites.front_default}
                                color={pokemon.types}
                            />
                        ))}
                    </div>
                    team 2: <Rate rate={team2winrate}/>
                </div>
            </div>
        );

    };
    return (
        <div className={""}>
            <h1 className={"text-center text-4xl uppercase pt-4"}>Team winrate calculator</h1>
            <button className="bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1 " onClick={calculateWinRate} >Get Rates</button>
            <button className="bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1 " onClick={Shuffle}>Shuffle team</button>
            <Link to={"/pokemons"}><button className="bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1 " >back</button></Link>
            <div>
                <Team1Page/>
                <Team2Page/>
            </div>

        </div>
    );
}





    export default TeamWinCal;